import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from "react";
import { Edit2, Trash2, Plus, Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Input } from "../../base/input/input";
import { InfoHint } from "../info-hint/info-hint";
export function DecisionTableHeader({ columns, onStartEditColumn, onSaveColumnName, onCancelEditColumn, onDeleteColumn, onAddColumn }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx("thead", {
        className: "sticky top-0 z-10 bg-surface-subtle/95 backdrop-blur-xs",
        children: /*#__PURE__*/ _jsxs("tr", {
            className: "border-b border-line",
            children: [
                /*#__PURE__*/ _jsx("th", {
                    className: "w-8 px-1 py-3"
                }),
                /*#__PURE__*/ _jsx("th", {
                    className: "w-16 px-4 py-3 text-sm font-semibold text-left text-fg-secondary",
                    children: t("viralRecording.labels.rule")
                }),
                columns.map((column, index)=>/*#__PURE__*/ _jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("th", {
                                className: "px-4 py-3 text-left text-sm font-semibold text-fg-secondary min-w-[200px] group",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-center justify-between gap-2",
                                    children: column.isEditing ? /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center flex-1 gap-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Input, {
                                                autoFocus: true,
                                                defaultValue: column.name,
                                                className: "h-8 text-sm",
                                                onKeyDown: (e)=>{
                                                    if (e.key === "Enter") {
                                                        onSaveColumnName(column.id, e.currentTarget.value);
                                                    } else if (e.key === "Escape") {
                                                        onCancelEditColumn(column.id);
                                                    }
                                                },
                                                onBlur: (e)=>onSaveColumnName(column.id, e.target.value)
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                onClick: ()=>onSaveColumnName(column.id, column.name),
                                                className: "p-1 text-positive rounded-sm hover:bg-positive-surface",
                                                children: /*#__PURE__*/ _jsx(Check, {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                onClick: ()=>onCancelEditColumn(column.id),
                                                className: "p-1 text-danger rounded-sm hover:bg-danger-surface",
                                                children: /*#__PURE__*/ _jsx(X, {
                                                    size: 16
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "flex-1",
                                                children: column.name
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex items-center gap-1 transition-opacity opacity-0 group-hover:opacity-100",
                                                children: [
                                                    /*#__PURE__*/ _jsx("button", {
                                                        onClick: ()=>onStartEditColumn(column.id),
                                                        className: "p-1.5 text-info hover:bg-info-surface rounded-sm transition-colors",
                                                        title: t("viralRecording.modals.decisionTable.editColumnName"),
                                                        children: /*#__PURE__*/ _jsx(Edit2, {
                                                            size: 14
                                                        })
                                                    }),
                                                    columns.length > 1 && /*#__PURE__*/ _jsx("button", {
                                                        onClick: ()=>onDeleteColumn(column.id),
                                                        className: "p-1.5 text-danger hover:bg-danger-surface rounded-sm transition-colors",
                                                        title: t("viralRecording.buttons.delete"),
                                                        children: /*#__PURE__*/ _jsx(Trash2, {
                                                            size: 14
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("th", {
                                className: "relative w-8 px-0 py-0",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "absolute inset-0 flex items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "absolute inset-y-0 w-px bg-surface-strong left-1/2"
                                        }),
                                        /*#__PURE__*/ _jsx("button", {
                                            onClick: ()=>onAddColumn(index),
                                            className: "relative z-10 p-1 text-fg-subtle transition-all bg-white border border-line rounded-full hover:text-info hover:bg-info-surface hover:border-info-line",
                                            title: t("viralRecording.buttons.addCondition"),
                                            "aria-label": t("viralRecording.buttons.addCondition"),
                                            children: /*#__PURE__*/ _jsx(Plus, {
                                                size: 14
                                            })
                                        })
                                    ]
                                })
                            }, `spacer-${column.id}`)
                        ]
                    }, column.id)),
                /*#__PURE__*/ _jsx("th", {
                    className: "px-4 py-3 text-left text-sm font-semibold text-fg-secondary min-w-[200px]",
                    children: /*#__PURE__*/ _jsxs("span", {
                        className: "inline-flex items-center gap-1.5",
                        children: [
                            t("viralRecording.labels.result"),
                            /*#__PURE__*/ _jsx(InfoHint, {
                                content: t("viralRecording.labels.outputHint")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("th", {
                    className: "w-16 px-4 py-3"
                })
            ]
        })
    });
}

//# sourceMappingURL=DecisionTableHeader.js.map